var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19C6.75875 19 2.38025 16.1175 0.753372 12.1999C2.38025 8.28235 6.75875 5.39995 12 5.39995C17.2412 5.39995 21.6197 8.28235 23.2466 12.2C21.6197 16.1175 17.2412 19 12 19Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8 12.2C15.8 14.2986 14.0987 16 12 16C9.90132 16 8.2 14.2986 8.2 12.2C8.2 10.1013 9.90132 8.39995 12 8.39995C14.0987 8.39995 15.8 10.1013 15.8 12.2Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEyeIcon);
export default __webpack_public_path__ + "static/media/whiteEyeIcon.ac6a93c3bbe82cb995c089ab80a599fa.svg";
export { ForwardRef as ReactComponent };